import { render } from "./FaultManagementView.vue?vue&type=template&id=971dc2da"
import script from "./FaultManagementView.vue?vue&type=script&lang=js"
export * from "./FaultManagementView.vue?vue&type=script&lang=js"

import exportComponent from "/root/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__